<template>
  <!-- Next component should appear on admin only -->
  <CustomAdminPage v-if="!dataStore.storefrontMode" />
  <GridTemplates />
</template>

<script setup>
import CustomAdminPage from "@/components/Admin/LayoutPages/CustomAdminPage";
import GridTemplates from "@/components/StylingTemplates/GridTemplates.vue";
import appDataStore from "@/stores/appDataStore";
import { onMounted } from "vue";

const dataStore = appDataStore();

// get media data
onMounted(() => {
  let output;
  if (dataStore.storefrontMode) {
    output = dataStore.responsiveCheck();
    console.log(output);
  }
  let imagesCount = 7;
  if (output?.columns === 2) {
    imagesCount = 5;
  }
  if (output?.columns === 1) {
    return;
  }
  dataStore.getMediaData(
    `https://ipfeed-api.numinix.com/api/return-account-type-data?limit=${imagesCount}`,
    "POST"
  );
});
</script>
